import React, { Component } from 'react'
import PropTypes from 'prop-types'
import HobnobModal from 'components/common/HobnobModal'
import TextInputElement from 'components/forms/TextInputElement'
import styles from './edit-modal.scss'
import CheckBoxInput from 'components/forms/CheckboxInput'
import WarnIcon from 'assets/icons/warn-icon.svg'
import SvgIcon from 'src/components/common/SvgIcon'
import { Tooltip, Select } from 'antd'
import { EMAIL_CONTACT_METHOD } from 'services/contact_methods'
import cn from 'classnames'
import { usersSelector } from 'src/selectors'
import { connect } from 'react-redux'
import TriangleDownIcon from 'src/assets/icons/triangle-down-icon.svg'
import NumberInputWithStepper from 'src/components/common/NumberInputWithStepper/NumberInputWithStepper'
import NoticeRed from 'assets/icons/ico-notice-red.png'

class EditModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      verifyInvitationGuestErrorMessage: '',
      confirmDisabled: false,
      yesTicketCounts: [],
      noTicketCounts: [],
      first_name: this.props.first_name || '',
      last_name: this.props.last_name || '',
      cohost: this.props.cohost || false,
      rsvpState: this.props.rsvpState || 'undecided'
    }
  }

  componentDidMount() {
    this.initializeData()
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.isOpenEditModal && this.props.isOpenEditModal) {
      this.initializeData()
      return
    }

    if (this.props.isOpenEditModal && (
      prevProps.ticketCounts !== this.props.ticketCounts ||
      prevProps.rsvpState !== this.props.rsvpState ||
      prevProps.cohost !== this.props.cohost ||
      prevProps.first_name !== this.props.first_name ||
      prevProps.last_name !== this.props.last_name
    )) {
      this.initializeData()
    }
  }

  initializeData = () => {
    const { ticketCounts, rsvpState, cohost, first_name, last_name } = this.props

    this.setState({
      first_name: first_name || '',
      last_name: last_name || '',
      cohost: cohost || false,
      rsvpState: rsvpState || 'undecided'
    })

    if (ticketCounts && ticketCounts.length > 0) {
      const yesTicketCounts = [...ticketCounts]

      const noTicketCounts = ticketCounts.map(item => ({
        ...item,
        count: 0
      }))

      this.setState({
        yesTicketCounts,
        noTicketCounts
      })
    }
  }

  getCurrentTicketCounts = () => {
    const { rsvpState } = this.state
    const { yesTicketCounts, noTicketCounts } = this.state

    if (rsvpState === 'accepted') {
      return yesTicketCounts
    } else if (rsvpState === 'declined') {
      return noTicketCounts
    } else {
      return noTicketCounts
    }
  }

  updateTicketCounts = (newItem) => {
    const { rsvpState } = this.state

    if (rsvpState === 'accepted') {
      const updatedYesTicketCounts = this.state.yesTicketCounts.map(item =>
        item.id === newItem.id ? newItem : item
      )
      this.setState({ yesTicketCounts: updatedYesTicketCounts }, () => {
        this._verifyInvitationGuest(updatedYesTicketCounts)
      })
    } else if (rsvpState === 'declined') {
      const updatedNoTicketCounts = this.state.noTicketCounts.map(item =>
        item.id === newItem.id ? newItem : item
      )
      this.setState({ noTicketCounts: updatedNoTicketCounts }, () => {
        this._verifyInvitationGuest(updatedNoTicketCounts)
      })
    }
  }

  handleCustomSave = () => {
    const currentTicketCounts = this.getCurrentTicketCounts()
    const { first_name, last_name, cohost, rsvpState } = this.state

    this.props.onSave({
      first_name,
      last_name,
      cohost,
      rsvpState,
      ticketCounts: currentTicketCounts
    })

    this._resetState()
  }

  _resetState = () => {
    this.setState({
      verifyInvitationGuestErrorMessage: '',
      confirmDisabled: false,
      yesTicketCounts: [],
      noTicketCounts: [],
      first_name: this.props.first_name || '',
      last_name: this.props.last_name || '',
      cohost: this.props.cohost || false,
      rsvpState: this.props.rsvpState || 'undecided'
    })
  }

  visibleCohost = () => {
    const { guestInfo, isHost, event } = this.props

    if (
      isHost &&
      (guestInfo?.delivery_state === 'delivered' || guestInfo?.delivery_state === 'viewed') &&
      event.host !== guestInfo?.guest
    ) {
      return true
    }

    return false
  }

  visibleFullName = () => {
    const { users, guestInfo } = this.props
    const user = users[guestInfo?.guest]

    if (user?.verified) {
      return false
    }

    return true
  }

  validateDate = () => {
    const { event } = this.props
    if (event.cutoff_date) {
      return new Date() > new Date(event.cutoff_date)
    }
    return false
  }

  _renderLabel = (countType) => {
    const { event } = this.props
    const { child_count_enabled } = event
    if (countType === 'adult') {
      if (!child_count_enabled) {
        return 'Total Guests'
      }
      return 'Adults'
    } else {
      return 'Children'
    }
  }

  _renderRows = (disabled) => {
    const { rsvpState } = this.state
    const currentTicketCounts = this.getCurrentTicketCounts()

    const inputChange = (value, item) => {
      const updatedItem = {
        ...item,
        count: parseInt(value)
      }

      this.updateTicketCounts(updatedItem)
    }

    if (!currentTicketCounts || currentTicketCounts.length === 0) return null

    return (
      <div className={styles['row']}>
        {currentTicketCounts.map(item => {
          return (
            <div key={item.id} className={styles['select-wrapper']}>
              <NumberInputWithStepper
                value={item.count}
                onChange={newValue => inputChange(newValue, item)}
                min={item.label === 'adult' ? 1 : 0}
                max={10}
                label={this._renderLabel(item.label)}
                disabled={rsvpState !== 'accepted' || disabled}
              />
              <input style={{ display: 'none' }} type='submit' />
            </div>
          )
        })}
      </div>
    )
  }

  _verifyInvitationGuest = (ticketCounts) => {
    const { rsvpState } = this.state

    if (rsvpState !== 'accepted') {
      this.setState({
        verifyInvitationGuestErrorMessage: '',
        confirmDisabled: false
      })
      return true
    }

    const {
      event: { max_capacity, limit_per_invitation },
      eventTicketCounts,
      ticketTypes
    } = this.props

    const activeTicketTypes = ticketTypes.filter(item => !item.archived_at)
    const activeTypeIds = activeTicketTypes.map(item => item.id)

    const otherAcceptedInvitations = eventTicketCounts.invitations.filter(invitation => invitation.rsvp_state === 'accepted' && invitation.id !== this.props.guestInfo.id)

    const otherGuest = otherAcceptedInvitations.reduce((sum, invitation) => {
      const invitationTicketCounts = invitation.ticket_counts.filter(tc => {
        return activeTypeIds.includes(tc.ticket_type_id)
      })
      const invitationTotal = invitationTicketCounts.reduce((acc, ticket) => acc + ticket.ticket_count, 0)
      return sum + invitationTotal
    }, 0)

    const totalTickets = ticketCounts.reduce((acc, ticket) => acc + ticket.count, 0)

    let errorMessage = ''
    let confirmDisabled = false

    if (limit_per_invitation !== 9999 && totalTickets > limit_per_invitation) {
      errorMessage = `This Event allows a maximum of ${limit_per_invitation} Guest(s) per invitation`
      confirmDisabled = true
    } else if (max_capacity !== 9999 && totalTickets + otherGuest > max_capacity) {
      errorMessage = `Your RSVP exceeds the event's maximum capacity`
      confirmDisabled = true
    }

    this.setState({
      verifyInvitationGuestErrorMessage: errorMessage,
      confirmDisabled
    })

    return !confirmDisabled
  }

  _handleRsvpChange = (value) => {
    const { ticketCounts } = this.props

    let newState = { rsvpState: value }

    if (value === 'accepted' || value === 'undecided') {
      newState.yesTicketCounts = [...ticketCounts]
    } else if (value === 'declined') {
      newState.noTicketCounts = ticketCounts.map(item => ({
        ...item,
        count: 0
      }))
    }

    this.setState(newState, () => {
      this._verifyInvitationGuest(this.getCurrentTicketCounts())
    })
  }

  _handleFieldChange = (field) => (e) => {
    const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value
    this.setState({ [field]: value })
  }

  _onClose = () => {
    this._resetState()
    this.props.onClose()
  }

  render() {
    const {
      isOpenEditModal,
      guestInfo,
      needPayTicket,
      event
    } = this.props
    const disableCohost = guestInfo?.contact_method.type === EMAIL_CONTACT_METHOD

    const { first_name, last_name, cohost, rsvpState } = this.state

    const isOutOfDate = this.validateDate()

    return (
      <HobnobModal
        closeOnOuterClick={false}
        show={isOpenEditModal}
        onClose={this._onClose}
        visibleButton
        confirmText="save"
        onConfirm={this.handleCustomSave}
        confirmDisabled={this.state.confirmDisabled}
        containerStyles={{ padding: '26px 26px 40px 26px' }}
        buttonContainerClassName={styles['button-container']}
        cancelClassName={styles['cancel-button']}
      >
        <div className={styles['edit-modal-title']}>
          Edit Guest
        </div>
        {
          this.state.verifyInvitationGuestErrorMessage && (
            <div className={styles['error-message']}>
              <img src={NoticeRed} width="17" />
              {this.state.verifyInvitationGuestErrorMessage}
            </div>
          )
        }

        {
          !needPayTicket && this.visibleCohost() && (
            <>
              <div className={styles['rsvp-input-wrapper']}>
                <Select
                  className={styles['rsvp-select-antd']}
                  placeholder="Update RSVP"
                  value={rsvpState === 'undecided' ? undefined : rsvpState}
                  onChange={this._handleRsvpChange}
                  options={[
                    { value: 'accepted', label: 'Yes' },
                    { value: 'declined', label: 'No' }
                  ]}
                  getPopupContainer={trigger => trigger.parentNode}
                  suffixIcon={<SvgIcon icon={TriangleDownIcon} width={25} height={25} />}
                  disabled={isOutOfDate}
                />

                {
                  event.guest_count_enabled && (
                    this._renderRows(isOutOfDate)
                  )
                }
              </div>
            </>
          )
        }

        {this.visibleFullName() && (
          <div className={styles['input-wrapper']}>
            <TextInputElement
              className={styles['input-inner']}
              placeholder="First Name"
              onChange={this._handleFieldChange('first_name')}
              valid
              value={first_name}
            />
            <TextInputElement
              className={styles['input-inner']}
              placeholder="Last Name"
              onChange={this._handleFieldChange('last_name')}
              valid
              value={last_name}
            />
          </div>
        )}

        {this.visibleCohost() && (
          <div className={styles['cohost-wrapper']}>
            <div
              className={cn(styles['cohost-inner'], {
                [styles['cohost-inner-disabled']]: disableCohost
              })}
            >
              <CheckBoxInput
                disabled={disableCohost}
                className={styles['check-inner']}
                onChange={this._handleFieldChange('cohost')}
                checked={cohost}
                size={20}
              />
              <span>Add as Cohost</span>
            </div>

            <Tooltip title="Cohost must have a phone number" zIndex="100000">
              <SvgIcon icon={WarnIcon} className={styles['warn-icon']} />
            </Tooltip>
          </div>
        )}
      </HobnobModal>
    )
  }
}

EditModal.propTypes = {
  first_name: PropTypes.string,
  last_name: PropTypes.string,
  cohost: PropTypes.bool,
  isOpenEditModal: PropTypes.bool,
  isHost: PropTypes.bool,
  guestInfo: PropTypes.object,
  event: PropTypes.object,
  users: PropTypes.object,
  needPayTicket: PropTypes.bool,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
  rsvpState: PropTypes.string,
  ticketCounts: PropTypes.array,
  eventTicketCounts: PropTypes.object,
  ticketTypes: PropTypes.array
}

function mapStateToProps(state) {
  return {
    users: usersSelector(state)
  }
}

export default connect(mapStateToProps)(EditModal)
